import $ from 'jquery'
import Swiper from './utils/getSwiper'

function init () {
  $('.inpage-navigation').each(function () {
    initSlider($(this))
  })
}

function initSlider (container) {
  let sliderContainer = container.find('.inpage-navigation-slider'),
    sliderLeftArrow = sliderContainer.find('.inpage-navigation-arrow-wrapper-prev'),
    sliderRightArrow = sliderContainer.find('.inpage-navigation-arrow-wrapper-next'),
    currentIndex = sliderContainer.find('.swiper-slide').index($('.current'))

  let inpageNavSlider = new Swiper(sliderContainer.get(0), {
    slidesPerView: 'auto',
    navigation: {
      nextEl: sliderRightArrow.get(0),
      prevEl: sliderLeftArrow.get(0),
    },
    speed: 300,
    watchSlidesProgress: true,
    allowTouchMove: false,
    watchSlidesVisibility: true,
    watchOverflow: true,
    centeredSlides: false,
    preventClicksPropagation: false,
    preventClicks: false,
    breakpoints: {
      // when window width is <= 992px md
      992: {
        allowTouchMove: true,
        centeredSlides: false,
      },
      // when window width is <= 576px xs
      576: {
        allowTouchMove: true,
        centeredSlides: true,
        slideToClickedSlide: true
      }
    },
    on: {
      init: function () {
        sliderLeftArrow.find('.inpage-navigation-arrow').removeClass('d-none')
        sliderRightArrow.find('.inpage-navigation-arrow').removeClass('d-none')
      }
    }
  })

  inpageNavSlider.slideTo(currentIndex)
}

export default {
  init
}
